import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Box, Typography } from "@mui/material";
import { Formik, Field, Form } from "formik";
import { object, string } from "yup";
import { loginService } from "../utils/login";
import { translate } from "i18n";
import { Subscription } from "rxjs";
import { acrAPI } from "../utils/api";
export class Login extends React.Component {
  private subscribtions: Subscription = new Subscription();

  public state = { badLoginCredential: false, localStorageLoaded: false };
  
  constructor(props: any) {
    super(props);
    this.updateLocalStorageLoaded = this.updateLocalStorageLoaded.bind(this);
  }
  private updateLocalStorageLoaded(localStorageLoaded: boolean): void {
    this.setState({ localStorageLoaded });
  }
  public componentDidMount(): void {
    this.subscribtions.add(acrAPI.isLocalStorageLoadedSubject.subscribe(this.updateLocalStorageLoaded));
  }
  public async handleSubmit(data: any): Promise<void> {
    loginService
      .authenticate({
        login: data.login,
        password: data.password,
      })
      .catch((e) => {
          this.setState({ badLoginCredential: true });
      });
  }
  public render(): JSX.Element {
    return (
      <Box style={{ maxWidth: "30%", margin: "auto" }}>
        {this.state.localStorageLoaded === true && 
        <Formik
          initialValues={{ login: "", password: "" }}
          enableReinitialize={false}
          onSubmit={(values) => this.handleSubmit(values)}
          validationSchema= {object({ login: string().required(translate("user name is required")),
                                      password: string().required(translate("password is required")),
                            })}>
          {({ handleSubmit, handleChange, values, errors }) => (
            <Form translate="no" method="POST" onSubmit={handleSubmit}>
              <Box display="flex" flexDirection="column">
                <Field
                  component={TextField}
                  variant="outlined"
                  margin="normal"
                  id="login"
                  label={translate("login")}
                  name="login"
                  helperText={errors.login}
                  onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => handleChange(e)}
                  value={values.login}
                  data-cy="login-user"
                />
                <Field
                  component={TextField}
                  variant="outlined"
                  margin="normal"
                  id="password"
                  name="password"
                  label={translate("password")}
                  helperText={errors.password}
                  onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => handleChange(e)}
                  type="password"
                  value={values.password}
                  data-cy="login-password"
                />
                {this.state.badLoginCredential && <Typography color="error">{translate("bad login")}</Typography>}
                <Button type="submit" id="formSubmit" variant="contained" data-cy="login-signin-button" color="primary">
                  {translate("sign in")}
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
        }
      </Box>
    );
  }
}
